import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const CAPI = `${BASE}/api`;

const capi = axios.create({ baseURL: CAPI });

export function saveConsumerAuth(data) {
  if (data?.token) localStorage.setItem("lx_consumer_token", data.token);
  if (data?.refresh_token) localStorage.setItem("lx_consumer_refresh", data.refresh_token);
}
export function clearConsumerAuth() {
  localStorage.removeItem("lx_consumer_token");
  localStorage.removeItem("lx_consumer_refresh");
}

capi.interceptors.request.use((config) => {
  const token = localStorage.getItem("lx_consumer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;
export async function tryRefresh() {
  const rt = localStorage.getItem("lx_consumer_refresh");
  if (!rt) return null;
  if (!refreshing) {
    refreshing = axios
      .post(`${CAPI}/consumer/auth/refresh`, { refresh_token: rt })
      .then((r) => { saveConsumerAuth(r.data); return r.data.token; })
      .catch(() => {
        // Another tab/app may have just rotated the token — use theirs instead of signing out.
        const cur = localStorage.getItem("lx_consumer_refresh");
        if (cur && cur !== rt) return localStorage.getItem("lx_consumer_token");
        clearConsumerAuth(); return null;
      })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
}

capi.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    const isAuthCall = url.includes("/auth/refresh") || url.includes("/auth/login");
    if (err.response?.status === 401 && !cfg._retry && !isAuthCall) {
      cfg._retry = true;
      const nt = await tryRefresh();
      if (nt) {
        cfg.headers = cfg.headers || {};
        cfg.headers.Authorization = `Bearer ${nt}`;
        return capi(cfg);
      }
      if (localStorage.getItem("lx_consumer_token")) return Promise.reject(err);
      clearConsumerAuth();
      if (!url.includes("/auth/me") && !["/login", "/create"].includes(window.location.pathname)) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default capi;

// Proactively renew the consumer session before the 15-min access token expires, so long-running
// screens (live mediation, recordings, voice) never hit an expired token mid-request.
const expSoon = () => {
  const t = localStorage.getItem("lx_consumer_token");
  if (!t || !localStorage.getItem("lx_consumer_refresh")) return false;
  try { const { exp } = JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))); return exp * 1000 - Date.now() < 3 * 60 * 1000; }
  catch { return false; }
};
const keepAlive = () => { if (expSoon()) tryRefresh(); };
setInterval(keepAlive, 60 * 1000);
document.addEventListener("visibilitychange", () => { if (!document.hidden) keepAlive(); });
